/// <amd-module name="Favorites/Common/Telemetry" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export interface IFavoritesTelemetryService extends IVssService {
    publishNavigateEvent(favoriteType: string, source: string): void;
}

class FavoritesTelemetryService extends VssService implements IFavoritesTelemetryService {
    public publishNavigateEvent(favoriteType: string, source: string): void {
        this.publishEvent("onclick", { favoriteType, source });
    }

    private publishEvent(feature: string, properties: { [key: string]: any }): void {
        const telemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("Favorites", feature, properties);
    }
}

Services.add("IFavoritesTelemetryService", { serviceFactory: FavoritesTelemetryService });

/**
 * Tracks cases in which favorites helped users navigate to artifacts.
 *
 * Do NOT use this just because the artifact happens to be a favorite. Only use this if the favorites service helped the user to perform the navigation.
 * For example:
 *  DO NOT use this if you have a directory view with a "Continue where you left off" section, and the user clicks on an artifact that is a favorite. The favorites service did not help the user to make this navigation.
 *  DO use this if you have a "Favorites" section, and the user clicked on the artifact from this section.
 *
 * @param favoriteType The favorite type (referred to as artifactType in some places)
 * @param source A unique identifier for the UI from which the favorite is being clicked. For example "Dashboards Directory View", or "Favorites Panel".
 */
export function publishNavigateEvent(pageContext: IVssPageContext, favoriteType: string, source: string) {
    const favoritesTelemetryService = pageContext.getService<IFavoritesTelemetryService>("IFavoritesTelemetryService");
    return favoritesTelemetryService.publishNavigateEvent(favoriteType, source);
}
